import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Pagination from "@mui/material/Pagination";
import { green, yellow } from "@mui/material/colors";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DemoPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: "left",
}));

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

export default function Orders() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const [open, setOpen] = useState(false);
  const [deliveryStatus, setDeliveryStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const isAdminVerified = sessionStorage.getItem("adminVerified");
  const [orderRows, setOrderRows] = useState(1);

  const [orders, setOrders] = useState([
    {
      order_id: 1,
      customer_id: 1,
      order_items: [
        {
          prod_id: 1,
          prod_quan: 1,
          prod_name: "Kodak ColorPlus 200 Color 35mm film (36 shots)",
          prod_image:
            "https://res.cloudinary.com/dpkmurosp/image/upload/v1749486163/5_r8vrgv.jpg",
          prod_features:
            "Daylight-Balanced Color Negative Film/ISO 200|24° in C-41 Process/Fine Grain and High Sharpness/Wide Exposure Latitude\n",
          prod_desc:
            "Kodak ColorPlus 200 is a versatile medium-speed daylight-balanced color negative film, characterized by its fine grain structure, high sharpness, and rich color saturation. It has a nominal sensitivity of ISO 200/24° along with a wide exposure latitude for exposing up to two stops under or three stops over to enable working in a wide variety of lighting.\n\nExpiration Date: 06/2027",
          prod_expiry: "1899-11-29T17:04:35.000Z",
          prod_var: "Kodak",
          prod_preorder: "no",
          prod_price: 799,
          prod_sale: 649,
          prod_stock: 100,
          prod_category: "35mm Film",
          prod_collection: 1,
          prod_popular: "yes",
          prod_limited: "no",
        },
      ],
      order_status: "Pending",
      payment_status: "Waiting for Payment",
      total_amount: 649,
      shipping_fee: "100",
      order_payment: "Gcash",
      order_courier: "Same Day Delivery",
      order_date: "2026-06-21 08:09:14",
    },
  ]);

  // function generate(element) {
  //   return orders.map((value) =>
  //     React.cloneElement(element, {
  //       key: value,
  //     }),
  //   );
  // }

  const handleDeliveryChange = (event) => {
    setDeliveryStatus(event.target.value || "");
  };

  const handlePaymentChange = (event) => {
    setPaymentStatus(event.target.value || "");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  useEffect(() => {
    axios
      .get(`${baseURL}/orders`, {
        responseType: "json", // Assuming the server response is in JSON format
      })
      .then((res) => res.data)
      .then((data) => {
        const orders = data.map((order) => order);
        setOrderRows(data.count);
        setOrders(prod);
      })
      .catch((error) => {
        console.error("Error fetching the products:", error);
      });
  }, []);

  return (
    <div className="OrdersList">
      <Stack direction="column">
        <DemoPaper variant="outlined">
          {" "}
          <Stack direction="column" spacing={0}>
            {" "}
            <Stack
              direction="row"
              alignItems="flex-end"
              justifyContent="space-between"
            >
              <Container>
                <h2>Orders</h2>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" href="/">
                    MUI
                  </Link>
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/material-ui/getting-started/installation/"
                  >
                    Core
                  </Link>
                  <Link
                    underline="hover"
                    color="text.primary"
                    href="/material-ui/react-breadcrumbs/"
                    aria-current="page"
                  >
                    Breadcrumbs
                  </Link>
                </Breadcrumbs>
              </Container>{" "}
            </Stack>
          </Stack>
        </DemoPaper>
      </Stack>
      {/* <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
        Avatar with text and icon
      </Typography> */}

      <Grid container direction={"column"} spacing={1}>
        <Box component="section" sx={{ p: 1 }}>
          {orders.map((order) => (
            <Item>
              <Grid container direction={"column"} sx={{ p: 1.5 }} spacing={1}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <Box sx={{ textAlign: "left" }}>
                    <h3>Summer Kate Nadela</h3>
                    <span>San Agustin, Trece Martires City, Cavite</span>
                  </Box>
                  <Box>
                    <h3>Order No. {order.order_id}</h3>
                    <i> {order.order_date}</i>
                  </Box>
                </Grid>
                <Demo>
                  <List dense={dense}>
                    {order.order_items.map((items) => (
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar src={items.prod_image}></Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={items.prod_name}
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                sx={{
                                  color: "text.primary",
                                  display: "inline",
                                }}
                              >
                                P
                                {items.prod_sale
                                  ? items.prod_sale
                                  : items.prod_price}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </Demo>
                <hr />{" "}
                <Grid
                  container
                  direction={"row"}
                  sx={{ justifyContent: "space-between" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span>P{order.shipping_fee}</span>
                    <span>{order.order_courier}</span>
                    <i style={{ fontSize: "x-small" }}>{order.order_status}</i>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "large" }}>
                      Total:{" "}
                      <b style={{ fontSize: "xx-large" }}>
                        {" "}
                        {Number(order.total_amount) +
                          Number(order.shipping_fee)}
                      </b>
                    </span>{" "}
                    <span style={{ fontSize: "small" }}>
                      {order.order_payment}
                    </span>
                    <i style={{ fontSize: "x-small" }}>
                      {order.payment_status}
                    </i>
                  </Box>
                </Grid>
              </Grid>

              <div>
                <Button onClick={handleClickOpen}>Update order status</Button>
                <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
                  <DialogTitle>Update order status</DialogTitle>
                  <DialogContent>
                    <Box
                      component="form"
                      sx={{ display: "flex", flexWrap: "wrap" }}
                    >
                      <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <InputLabel htmlFor="demo-dialog-native">
                          Delivery
                        </InputLabel>
                        <Select
                          native
                          value={order.order_status}
                          onChange={(event) => {
                            const newStatus = event.target.value;
                            setOrders((prevOrders) =>
                              prevOrders.map((item) =>
                                item.order_id === order.order_id
                                  ? { ...item, order_status: newStatus }
                                  : item,
                              ),
                            );
                          }}
                          input={
                            <OutlinedInput
                              label="Delivery Status"
                              id="demo-dialog-native"
                            />
                          }
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Shipped"}>Shipped</option>
                          <option value={"Delivered"}>Delivered</option>
                        </Select>
                      </FormControl>
                      <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <InputLabel id="demo-dialog-select-label">
                          Payment
                        </InputLabel>
                        <Select
                          labelId="demo-dialog-select-label"
                          id="demo-dialog-select"
                          value={order.payment_status}
                          onChange={(event) => {
                            const newStatus = event.target.value;
                            setOrders((prevOrders) =>
                              prevOrders.map((item) =>
                                item.order_id === order.order_id
                                  ? {
                                      ...item,
                                      payment_status: newStatus,
                                    }
                                  : item,
                              ),
                            );
                          }}
                        >
                          <MenuItem value={"Waiting for Payment"}>
                            Unpaid
                          </MenuItem>
                          <MenuItem value={"Paid"}>Paid</MenuItem>
                          <MenuItem value={"Failed"}>Failed</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleClose}>Ok</Button>
                  </DialogActions>
                </Dialog>
              </div>
            </Item>
          ))}
        </Box>
      </Grid>

      <Stack spacing={2}>
        <Pagination count={orderRows} variant="outlined" shape="rounded" />
      </Stack>
    </div>
  );
}
